
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.953 20.62a6.666 6.666 0 014.714-1.953h10.666A6.667 6.667 0 0128 25.333V28a1.333 1.333 0 01-2.667 0v-2.667a4 4 0 00-4-4H10.667a4 4 0 00-4 4V28A1.333 1.333 0 114 28v-2.667c0-1.768.702-3.463 1.953-4.714zM16 5.333a4 4 0 100 8 4 4 0 000-8zm-6.667 4a6.667 6.667 0 1113.334 0 6.667 6.667 0 01-13.334 0z","fill":"#BD2C43"}})])
          )
        }
      }
    